import * as i18n from 'i18next'

import { SupportedLanguages } from 'shared/types/types'

const SUPPORTED_LANGUAGES = [SupportedLanguages.RU, SupportedLanguages.GE] as const

export const getNormalizedLanguage = (): SupportedLanguages => {
  const currentLanguage = i18n.default.language.split('-')[0]
  if (SUPPORTED_LANGUAGES.includes(currentLanguage as SupportedLanguages)) {
    return currentLanguage as SupportedLanguages
  }
  return SupportedLanguages.RU
}

export const isLanguage = (language: SupportedLanguages): boolean => {
  return getNormalizedLanguage() === language
}
